import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { CurrentUserClient, type CurrentUserDrawerResponse } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { USER_PROFILE_DRAWER_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";

export function useGetUserProfileDrawerProfile(enabled: boolean) {
  const api = useApi(CurrentUserClient);

  return useQuery<CurrentUserDrawerResponse, Error>({
    queryKey: [USER_PROFILE_DRAWER_QUERY_KEY],
    queryFn: async () => await api.getUserProfileDrawer(),
    enabled,
    staleTime: ms("5m"),
  });
}
